import { ADD_TO_BE_DELETED } from './type'

export const addToBeDeleted = (deleteOrder:number, categories:[]) => {
  return  {
    type: ADD_TO_BE_DELETED,
    deleteOrder,
    categories
  }
}
